<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <!-- <div class="personal-details">
          <h4 class="personal-details-title">Product Category List</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Id</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of productCategoryList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <th scope="col">{{product.productCategoryId}}</th>
                <th scope="col">{{product.name}}</th>
                <th scope="col">{{product.description}}</th>
                <th>
                  <i class="bi bi-eye-fill" (click)="getProductCategoryById(product.productCategoryId)" data-toggle="modal" data-target="#exampleModalView" ></i>
                </th>
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="productCategoryList.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div> -->


        <div class="personal-details" *ngIf="!isView && !isAdd && !isEdit">
         
  
          <div class="header-block">
            <div class="header-title">
              <p>Product Category List</p>
            </div>
            <div class="add-block">
              <div class="search">
                <form autocomplete="off" >
                  <input type="text" placeholder="search">
                </form>
                <i class="bi bi-search" ></i>
              </div>
              <button *ngIf="actionControls.isAdd" (click)="openAdd()"><i class="bi bi-plus-lg"></i> Add</button>
            </div>
          </div>
  
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 25%;">Id</th>
                <th style="width: 25%;">Name</th>
                <th style="width: 25%;">Description</th>
                <th style="width: 25%;text-align: center;padding: 0;" class="">Action</th>
              </tr>
            </thead>
          </table>
          <div *ngIf="!isLoading">
            <div class="data-view" *ngFor="let product of productCategoryList | paginate : {
              itemsPerPage: tableSize,
              currentPage: page,
              totalItems: count};let i = index">
              <p style="width: 25%">{{product.productCategoryId}}</p>
              <p style="width: 25%">{{product.name}}</p>
              <p style="width: 25%">{{product.description}}</p>
             
              <p class="action-buttons" style="width: 25%;padding-left: 25px;">
                <i *ngIf="actionControls.isModify" class="bi bi-pencil-square" (click)="getProductCategoryById1(product.productCategoryId)" ></i>
                <i *ngIf="actionControls.isView" class="bi bi-eye-fill" (click)="getProductCategoryById(product.productCategoryId)" data-toggle="modal" data-target="#exampleModalView" ></i>
                <i *ngIf="actionControls.isDelete" class="bi bi-trash3" (click)="selectProductCategory(product.id)" data-toggle="modal" data-target="#deleteModal"></i>
              </p>
            </div>
          </div>
  
  
          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>
  
          <div class="loader"  *ngIf="!isLoading && productCategoryList.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div>
  
          <div class="paginator">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
              [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
  
        </div>





  
  
        <div class="personal-details" *ngIf="isAdd">
          <div class="header-block">
            <div class="header-title">
              <p>Add Product Category</p>
            </div>
            <div class="add-block">
            
              <button (click)="closeAdd()"> Back</button>
            </div>
          </div>

          <div cdkDropListGroup class="composition-block">
            <div class="example-container-left">
              <h2>Products</h2>
          
              <div
                cdkDropList
                [cdkDropListData]="cProductList"
                class="example-list1"
                (cdkDropListDropped)="drop($event)">
                <div class="example-box1" *ngFor="let item of cProductList" cdkDrag>{{item.name}}</div>
              </div>
            </div>
          
            <div class="example-container-right">
              <h2>Product Category</h2>
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <input type="text" placeholder="enter name" [(ngModel)]="name" class="form-control">
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group ">
                      <ng-multiselect-dropdown
                      [placeholder]="'select sub categories'"
                      [settings]="dropdownSettings"
                      [data]="categoryList"
                      [(ngModel)]="selectedCategoryList"
                      class="form-control"
                      style="padding: 0;border: none"
                      (onSelect)="onItemSelect($event)"
                      (onSelectAll)="onSelectAll($event)"
                      >
                      </ng-multiselect-dropdown>
                    </div> 
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group image-b" *ngIf="imageUrl == ''">
                      <button class="" (click)="imageButtonClick()">add category image</button>
                      <input type="file" id="imageInput" (change)="onChange($event)" accept="image/*" [style.display]="'none'">
                  </div>
                  <div class="form-group image-view" *ngIf="imageUrl != ''">
                      <label>Category Image </label>
                      <img [src]="imageUrl" alt="" srcset="">
                      <button class="btn btn-secondary" (click)="imageRemove()">Remove</button>
                  </div>
              </div>
              <div class="col-md-6 col-lg-6 display-checkbox">
                <input type="checkbox" [(ngModel)]="isHomePage">
                <label for="">Display in home page</label>
              </div>
                <div class="col-md-12 col-lg-12">
                  <input type="text" placeholder="enter description" class="form-control" [(ngModel)]="description">
                </div>
              </div>
         

              <div
                cdkDropList
                [cdkDropListData]="done"
                class="example-list"
                (cdkDropListDropped)="drop($event)">
                <div class="example-box" *ngFor="let item of done" cdkDrag>
                  <div class="row input-data">
                    <!-- <div class="col-md-12 col-lg-12">
                      <p>{{item.name}}</p>
                    </div> -->
                    <div class="col-md-6 col-lg-6">
                      <label for="">Name:</label>
                      <p>{{item.name}}</p>
                    </div>
                    <div class="col-md-6 col-lg-6">
                      <label for="">ProductId:</label>
                      <p>{{item.productId}}</p>
                    </div>
                    <div class="col-md-6 col-lg-6">
                      <label for="">Quantity:</label>
                      <p>{{item.quantity}}</p>
                    </div>
                    <div class="col-md-6 col-lg-6">
                      <label for="">Uom:</label>
                      <p>{{item.uom}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-primary" (click)="add()">submit</button>
              </div>
            </div>
        </div>
        </div>   


        <div class="personal-details" *ngIf="isEdit">

          <div class="header-block">
            <div class="header-title">
              <p>Edit Product Category</p>
            </div>
            <div class="add-block">
            
              <button (click)="closeAdd()"> Back</button>
            </div>
          </div>
          <div cdkDropListGroup class="composition-block">
              <div class="example-container-left">
                <h2>Products</h2>
            
                <div
                  cdkDropList
                  [cdkDropListData]="cProductList"
                  class="example-list1"
                  (cdkDropListDropped)="drop($event)">
                  <div class="example-box1" *ngFor="let item of cProductList" cdkDrag>{{item.name}}</div>
                </div>
              </div>
            
              <div class="example-container-right">
                <h2>Product Category</h2>
                <div class="row">
                  <div class="col-md-6 col-lg-6">
                    <input type="text" placeholder="enter name" [(ngModel)]="name" class="form-control">
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group ">
                        <ng-multiselect-dropdown
                        [placeholder]="'select sub categories'"
                        [settings]="dropdownSettings"
                        [data]="categoryList"
                        [(ngModel)]="subCategoryList"
                        class="form-control"
                        style="padding: 0;border: none"
                        (onSelect)="onItemSelect($event)"
                        (onSelectAll)="onSelectAll($event)"
                        >
                        </ng-multiselect-dropdown>
                      </div> 
                  </div>
                  <div class="col-md-6 col-lg-6">
                    <div class="form-group image-b" *ngIf="imageUrl == ''">
                      <button class="" (click)="imageButtonClick()">add category image</button>
                      <input type="file" id="imageInput" (change)="onChange($event)" accept="image/*" [style.display]="'none'">
                    </div>
                    <div class="form-group image-view" *ngIf="imageUrl != ''">
                      <label>Category Image </label>
                      <img [src]="imageUrl" alt="" srcset="">
                      <button class="btn btn-secondary" (click)="imageRemove()">Remove</button>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 display-checkbox">
                    <input type="checkbox" [(ngModel)]="isHomePage">
                    <label for="">Display in home page</label>
                  </div>
                  <div class="col-md-12 col-lg-12">
                    <input type="text" placeholder="enter description" class="form-control" [(ngModel)]="description">
                  </div>
                </div>
           

                <div
                  cdkDropList
                  [cdkDropListData]="done"
                  class="example-list"
                  (cdkDropListDropped)="drop($event)">
                  <div class="example-box" *ngFor="let item of done" cdkDrag>
                    <div class="row input-data">
                      <!-- <div class="col-md-12 col-lg-12">
                        <p>{{item.name}}</p>
                      </div> -->
                      <div class="col-md-6 col-lg-6">
                        <label for="">Name:</label>
                        <p>{{item.name}}</p>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <label for="">ProductId:</label>
                        <p>{{item.productId}}</p>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <label for="">Quantity:</label>
                        <p>{{item.quantity}}</p>
                      </div>
                      <div class="col-md-6 col-lg-6">
                        <label for="">Uom:</label>
                        <p>{{item.uom}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn btn-secondary" (click)="closeEdit()">Cancel</button>
                  <button class="btn btn-primary" (click)="editProductCategory()">submit</button>
                </div>
              </div>
          </div>
      </div>

      </div>
    </div>
</div>


<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Product Category Data
            <span data-dismiss="modal">
              <i data-dismiss="modal" class="bi bi-x-lg"></i>
            </span>
          </h5>
        </div>
        <div class="modal-body view">
          <div *ngFor="let product of singleProductCategoryData">
            <div class="row">
              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Name</label>
                  <input type="text" readonly value="{{product.name}}" class="form-control">
                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Description</label>
                  <input type="text" readonly value="{{product.description}}" class="form-control">
                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="form-group imageUrl">
                  <label>imageUrl</label><br>
                  <img *ngIf="product.imageUrl == '' || product.imageUrl == null" src="assets/img/dummy.png" alt="">
                  <img *ngIf="product.imageUrl != '' && product.imageUrl != null" src="{{product.imageUrl}}" alt="">
                </div>
              </div>

              <div class="col-md-6 col-lg-6">
                <div class="form-group">
                  <label>isHomePage</label>
                  <input type="text" readonly value="{{product.isHomePage}}" class="form-control">
                </div>
              </div>
            </div>

            <div class="sub-category-list">
              <h4>Sub Category</h4>
              <div class="sub-category-block">
                <div class="sub-category" *ngFor="let subCategory of product.subCategoryList">
                  <img *ngIf="subCategory.url == '' || subCategory.url == null" src="assets/img/dummy.png" alt="">
                  <img *ngIf="subCategory.url != '' && subCategory.url != null" src="{{subCategory.url}}" alt="" >
                  <p>{{subCategory.categoryName}}</p>
                </div>
              </div>
            </div>

            <table class="table table-striped" style="margin-bottom: 0;padding-bottom: 0;">
              <thead>
                <tr>
                  <th style="width: 10%;">ProductId</th>
                  <th style="width: 30%;text-align: center;">Name</th>
                  <th style="width: 30%;text-align: center;">Quantity</th>
                  <th style="width: 30%;text-align: center;">Uom</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let productInfoObjList of product.productObjList;let i = index">
                  <th>{{productInfoObjList.productId}}</th>
                  <th style="text-align: center;">{{productInfoObjList.name}}</th>
                  <th style="text-align: center;">{{productInfoObjList.quantity}}</th>
                  <th style="text-align: center;">{{productInfoObjList.uom}}</th>
                </tr>    
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>




  <div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
                  <span data-dismiss="modal">
                    <i data-dismiss="modal" class="bi bi-x-lg"></i>
                  </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>are you sure? want to delete??</p>   
                <div class="modal-footer">
                <button type="button" id="closeDelete" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" (click)="deleteProductCategory()" class="btn btn-primary">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>